import { cn } from '../../utils/cn';

const sizeStyles = {
  xs: 'w-6 h-6 text-[10px]',
  sm: 'w-7 h-7 text-xs',
  md: 'w-10 h-10 text-sm',
  lg: 'w-12 h-12 text-base',
};

const toneStyles = {
  brand:   'bg-brand-100 text-brand-700',
  accent:  'bg-accent-50 text-accent-700',
  neutral: 'bg-bg-subtle text-fg-muted',
  success: 'bg-status-success-soft text-status-success',
  warning: 'bg-status-warning-soft text-status-warning',
};

export function Avatar({ initials, src, size = 'md', tone = 'brand', className, alt }) {
  return (
    <div
      className={cn(
        'inline-flex items-center justify-center rounded-full font-semibold uppercase shrink-0 overflow-hidden',
        sizeStyles[size] ?? sizeStyles.md,
        !src && (toneStyles[tone] ?? toneStyles.brand),
        className,
      )}
      aria-label={alt}
    >
      {src ? (
        <img src={src} alt={alt ?? ''} className="w-full h-full object-cover dark-safe-img" />
      ) : (
        initials
      )}
    </div>
  );
}